import { createClient } from '@supabase/supabase-js';

const supabaseUrl = "https://vkoukkrxrecflyhimqcf.supabase.co";
const supabaseAnonKey = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InZrb3Vra3J4cmVjZmx5aGltcWNmIiwicm9sZSI6ImFub24iLCJpYXQiOjE3Nzg1MTA5MTQsImV4cCI6MjA5NDA4NjkxNH0.6J6vQPy1HvbmN3av6UW-TxqRUWTDWmakFxxd9HsjEgw";

export const supabase = createClient(supabaseUrl, supabaseAnonKey);
